import React from "react";

/**
 * AuditTimeline — vertical timeline render for ticket status_history.
 *
 * Read-only. Renders each entry as `from → to` with timestamp + actor.
 * Empty state shown when status_history is empty.
 */
export const AuditTimeline = ({ entries = [], dataTestId = "rl-audit-timeline" }) => {
  const items = Array.isArray(entries) ? entries : [];
  if (items.length === 0) {
    return (
      <div
        data-testid={`${dataTestId}-empty`}
        className="rounded-md border border-dashed border-slate-300 p-4 text-xs text-slate-500"
      >No history yet.</div>
    );
  }
  return (
    <ol data-testid={dataTestId} className="relative ml-2 space-y-3 border-l border-slate-200 pl-4">
      {items.map((e, i) => (
        <li key={i} data-testid={`${dataTestId}-entry-${i}`} className="relative">
          <span className="absolute -left-[21px] top-1.5 h-2.5 w-2.5 rounded-full bg-emerald-500" />
          <div className="flex flex-wrap items-baseline gap-2 text-xs">
            <code className="rounded bg-slate-100 px-1 py-0.5">{e.from || "—"}</code>
            <span className="text-slate-400">→</span>
            <code className="rounded bg-emerald-50 px-1 py-0.5 text-emerald-800">{e.to || "—"}</code>
            <span className="text-slate-500">
              {e.at ? e.at.slice(0, 19).replace("T", " ") : ""}
            </span>
          </div>
          {e.by && (
            <p className="mt-0.5 text-[10px] text-slate-400">by <code>{String(e.by).slice(0, 12)}</code></p>
          )}
          {e.notes && <p className="mt-0.5 text-xs text-slate-600">{e.notes}</p>}
        </li>
      ))}
    </ol>
  );
};

export default AuditTimeline;
